import { takeLatest, call } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { setPatientMedicationsOptions } from '../store/options.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { PatientMedicationsService } from '../../patientMedications/services/patientMedications.service'
import { setAreOptionsLoading } from '../../patientMedications/store/patientMedications.actions'
import { OptionsConstants } from '../store/options.constants'
import { filterHiddenOptions } from '../../../utilities/options.util'
import { IHideableOptionsResponse } from '../store/options.types'

export function* getPatientMedicationsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const medicationService = new PatientMedicationsService(serviceId)

  try {
    yield put(setAreOptionsLoading(true))
    const patientMedicationsOptionsResponse: IHideableOptionsResponse = yield call([
      medicationService,
      medicationService.getPatientMedicationsOptions,
    ])
    const { entity } = patientMedicationsOptionsResponse
    entity.sort((e1: any, e2: any) => e1.name.localeCompare(e2.name))

    yield put(setPatientMedicationsOptions(filterHiddenOptions(entity)))
    yield put(setAreOptionsLoading(false))
  } catch (e) {
    yield put(throwPcrException(`getPatientMedicationsOptions() error: ${e}`))
  }
}

export function* getPatientMedicationsOptionsSaga() {
  yield takeLatest([OptionsConstants.GET_MEDICATIONS_OPTIONS], getPatientMedicationsOptions)
}
